// export const servidorFrontEnd = 'http://localhost:3003/';
// const servidor = 'http://localhost';
// export const servidorBackEnd = servidor + ':' + '5003';

export const servidorFrontEnd = 'https://pmrn-fic-las-takeus.ibfc.org.br/';
export const servidorBackEnd = 'https://sis_pmrn_las_takeus.ibfc.org.br';

export const msgInicialErro = '<div class="notification is-danger"><u>Inutilize com traço</u> os espaços onde não houver resposta.<br/><b>Por favor, verifique abaixo e tente novamente:</b></div>';
export const diminuirAlturaBoxFooter = '157';